"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./index.module.css");
var classNames = require("classnames");
var md_1 = require("react-icons/md");
exports.ErrorMessage = function (_a) {
    var className = _a.className, message = _a.message;
    return (React.createElement("div", { className: classNames(styles.error, className) },
        React.createElement(md_1.MdError, { className: styles.icon }),
        React.createElement("p", { className: styles.message }, message)));
};
var Input = /** @class */ (function (_super) {
    __extends(Input, _super);
    function Input() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (e) {
            var _a = _this.props, disabled = _a.disabled, onChange = _a.onChange;
            if (!disabled && onChange) {
                onChange(e.target.value);
            }
        };
        return _this;
    }
    Input.prototype.render = function () {
        var _a = this.props, className = _a.className, placeholder = _a.placeholder, style = _a.style, _b = _a.type, type = _b === void 0 ? 'text' : _b, _c = _a.value, value = _c === void 0 ? '' : _c, error = _a.error, disabled = _a.disabled, onBlur = _a.onBlur, onFocus = _a.onFocus;
        return (React.createElement("div", { style: style, className: classNames(styles.input, error && styles.error, disabled && styles.disabled, className) },
            React.createElement("input", { type: type, className: styles.element, value: value, onChange: this.onChange, onFocus: onFocus, onBlur: onBlur, disabled: disabled }),
            !value && React.createElement("p", { className: styles.placeholder }, placeholder),
            typeof error === 'string' && error && React.createElement(exports.ErrorMessage, { message: error })));
    };
    return Input;
}(React.Component));
exports.default = Input;
